export function timeAgo(dateString: string): string {
  const now = new Date();
  const date = new Date(dateString);
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);
  if (diff < 60) return `${diff} seconds ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
  return `${Math.floor(diff / 86400)} days ago`;
};

export function getRelativeTime(dateString: string) {
  if (!dateString) return '';
  const now = new Date();
  const date = new Date(dateString);
  const diff = (now.getTime() - date.getTime()) / 1000; // seconds
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} minute${Math.floor(diff / 60) === 1 ? '' : 's'} ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hour${Math.floor(diff / 3600) === 1 ? '' : 's'} ago`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} day${Math.floor(diff / 86400) === 1 ? '' : 's'} ago`;
  if (diff < 31536000) return `${Math.floor(diff / 2592000)} month${Math.floor(diff / 2592000) === 1 ? '' : 's'} ago`;
  return `${Math.floor(diff / 31536000)} year${Math.floor(diff / 31536000) === 1 ? '' : 's'} ago`;
}


// Mock data
const mockActions = [
  {
    actionData: { mapId: '20876dbf-7205-4abf-9ff0-4862a7ec8caf' },
    actionName: 'rename_a_map',
    createdAt: '2025-06-24T06:19:16.653Z',
    id: '3cf5b92e-196a-440b-b232-e383d56065f0',
    invitedUserName: null,
    jobName: null,
    mapName: 'test',
    organisationId: 'f21b86ec-5d9c-4b55-9fe9-f807c9129c4f',
    updatedAt: '2025-06-24T06:19:16.653Z',
    user: {
      fname: 'Sarah',
      lname: 'Chen',
      profile_pic: null,
    },
    userScopeId: '69a63d13-296e-4fec-9c4f-249cce261731',
    workspaceName: null,
  },
  {
    actionData: { workspaceId: 'f21b86ec-5d9c-4b55-9fe9-f807c9129c4f', invitedUserId: '58a5a1' },
    actionName: 'invite_a_user',
    createdAt: '2025-06-24T05:50:15.002Z',
    id: '28b6911-9620-4afc-852d-d2e6d4fa25a7',
    invitedUserName: 'a a',
    jobName: null,
    mapName: null,
    organisationId: 'f21b86ec-5d9c-4b55-9fe9-f807c9129c4f',
    updatedAt: '2025-06-24T05:50:15.002Z',
    user: {
      fname: 'Marcus',
      lname: 'Rodriguez',
      profile_pic: null,
    },
    userScopeId: '69a63d13-296e-4fec-9c4f-249cce261731',
    workspaceName: 'Coastal_Survey_Project',
  },
  {
    actionData: {},
    actionName: 'upload_to_map',
    createdAt: '2025-06-24T04:00:00.000Z',
    id: '7fd5d7c5-7a8e-446c-bcc3-a97f8ad8f027',
    invitedUserName: null,
    jobName: null,
    mapName: 'Regional_Infrastructure_Map',
    organisationId: null,
    updatedAt: '2025-06-24T04:00:00.000Z',
    user: {
      fname: 'Marcus',
      lname: 'Rodriguez',
      profile_pic: null,
    },
    userScopeId: '69a63d13-296e-4fec-9c4f-249cce261731',
    workspaceName: null,
  },
  {
    actionData: {},
    actionName: 'processing_completed',
    createdAt: '2025-06-22T04:00:00.000Z',
    id: '85c60812-253f-4d0f-9e62-1406e41b59a0',
    invitedUserName: null,
    jobName: 'Traffic_Flow_Analysis',
    mapName: null,
    organisationId: null,
    updatedAt: '2025-06-22T04:00:00.000Z',
    user: {
      fname: 'David',
      lname: 'Kim',
      profile_pic: null,
    },
    userScopeId: '69a63d13-296e-4fec-9c4f-249cce261731',
    workspaceName: null,
  },
  {
    actionData: {},
    actionName: 'share_a_map',
    createdAt: '2025-06-04T04:00:00.000Z',
    id: '03c98331-17fa-496a-952a-e83e03998457',
    invitedUserName: null,
    jobName: null,
    mapName: 'Downtown_Development_Area',
    organisationId: null,
    updatedAt: '2025-06-04T04:00:00.000Z',
    user: {
      fname: 'Sarah',
      lname: 'Chen',
      profile_pic: null,
    },
    userScopeId: '69a63d13-296e-4fec-9c4f-249cce261731',
    workspaceName: null,
  },
];
